import {
  ListViewProvider,
  useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import {QueryRequestProvider} from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import {QueryResponseProvider} from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import {UsersListHeader} from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import {UsersTable} from '../../../data-administration/data-admininstration-list/table/UsersTable'
import {UserEditModal} from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import {KTCard, allCategory} from '../../../../../../_metronic/helpers'
import {roleColumns} from './_columns'
import CouponAnalyticsDashboard from './Couponanalyticsdashboard'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
const UsersList = () => {
  const {itemIdForUpdate} = useListView()


  const { responseData: voucherAnalytics } = useFetchCommon({
    api: `analytics/vouchers`,
    isDropDown: false,
  })

  return (
    <KTCard>
      {/* <UsersListHeader placeholder='Search Sponsor' label='Add' /> */}
      <CouponAnalyticsDashboard analyticsData={voucherAnalytics} />
      <UsersTable columnProps={roleColumns} />
      <UserEditModal formName='CouponsModalForm' />
    </KTCard>
  )
}

const CouponsWrapper2 = () => {
  const getTokenFromStorage = () => {
    const authData = localStorage.getItem('kt-auth-react-v')
    if (authData) {
      try {
        const parsedData = JSON.parse(authData)
        return parsedData.data?.franchiseId
      } catch (e) {
        console.error('Error parsing auth data:', e)
      }
    }
    return null
  }

  const franchiseId = getTokenFromStorage()

  return (
    <QueryRequestProvider initialValue={{ initialApi: `coupons/franchisee/${franchiseId}` }}>
      <QueryResponseProvider>
        <ListViewProvider>
          <UsersList />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export { CouponsWrapper2 }
